<script setup lang="ts">
/* eslint-disable max-len */
</script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 9.4c2.2 0 4-1.844 4-4.098v-.204C12 2.844 10.2 1 8 1S4 2.844 4 5.098v.204C4 7.556 5.8 9.4 8 9.4zm4.6 1.4H3.4C1.52 10.8 0 12.678 0 15h16c0-2.298-1.52-4.2-3.4-4.2z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
